// src/config.js
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

export default API_BASE;
export { API_BASE };
